// src/services/NotificationPollingService.js - COMPLETE WITHOUT CLOUD FUNCTIONS

import { collection, query, where, onSnapshot, orderBy, limit } from 'firebase/firestore';
import { db, messaging, getToken, onMessage } from './firebaseConfig';
import { doc, updateDoc } from 'firebase/firestore';

class NotificationPollingService {
  constructor() {
    this.unsubscribe = null;
    this.lastOrderTime = Date.now();
    this.audio = null;
    this.messageUnsubscribe = null;
    this.initAudio();
  }

  initAudio() {
    const audioData = 'data:audio/wav;base64,UklGRvQGAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YdAGAAD/////AgD9/wMA/P8EAPv/BQD6/wcA+P8IAPf/CgD1/wwA8/8OAPn/DwD7/w8A/f8NAP//CwD//wkA//8HAP//BQD+/wMA/v8CAP7/AQD+/wAA/v////7////9/////f////3//v/9//7//f/+//3//f/9//3//f/9//3//P/9//z//f/8//3/+//9//v//P/7//z/+//8//v/+//7//v/+//7//v/+v/7//r/+//6//r/+v/6//r/+f/6//n/+v/5//n/+f/5//n/+P/5//j/+f/4//j/+P/4//j/+P/4//f/+P/3//j/9//3//f/9//3//f/9//3//f/9v/3//b/9//2//b/9v/2//b/9v/2//b/9v/2//b/9v/2//X/9v/1//b/9f/2//X/9f/1//X/9f/1//X/9f/1//X/9f/1//X/9f/1//X/9f/1//X/9f/1//X/9f/1//X/9f/1//X/9v/1//b/9f/2//b/9v/2//b/9v/2//b/9//2//f/9//3//f/9//3//f/+P/3//j/+P/4//j/+P/5//j/+f/5//n/+f/5//n/+v/5//r/+v/6//r/+v/6//v/+v/7//v/+//7//v/+//8//v//P/8//z//P/8//z//f/8//3//f/9//3//f/9//7//f/+//7//v/+//7//v////7/////////////////////////////////////////AQD//wEA//8BAP//AgD+/wIA/v8CAP7/AgD+/wMA/f8DAP3/AwD9/wQA/P8EAPz/BAD8/wQA/P8FAPv/BQD7/wUA+/8FAPv/BgD6/wYA+v8GAPr/BgD6/wcA+f8HAPn/BwD5/wcA+f8IAPj/CAD4/wgA+P8IAPj/CQD3/wkA9/8JAPf/CQD3/woA9v8KAPb/CgD2/woA9v8LAP3/CgD//wkA//8IAP//BwD//wYA//8EAP//AwD//wIA//8BAP//AAD+/////v////7////+/////f////3////9//7//f/+//3//v/9//3//f/9//3//f/9//z//f/8//3//P/8//z//P/8//z//P/7//z/+//8//v/+//7//v/+//7//v/+v/7//r/+//6//r/+v/6//r/+f/6//n/+v/5//n/+f/5//n/+P/5//j/+f/4//j/+P/4//j/+P/4//f/+P/3//j/9//3//f/9//3//f/9//3//f/9v/3//b/9//2//b/9v/2//b/9v/2//X/9v/1//b/9f/1//X/9f/1//X/9f/0//X/9P/1//T/9f/0//T/9P/0//T/9P/0//T/9P/0//T/9P/0//T/9P/0//T/9P/0//T/9P/0//T/9P/0//T/9P/0//T/9P/1//T/9f/1//X/9f/1//X/9f/1//b/9f/2//b/9v/2//b/9v/2//f/9v/3//f/9//3//f/9//4//f/+P/4//j/+P/4//j/+f/4//n/+f/5//n/+f/5//r/+f/6//r/+v/6//r/+//6//v/+//7//v/+//7//z/+//8//z//P/8//z//P/9//z//f/9//3//f/9//7//f/+//7//v/+//7///////7////+/////////////////////w==';
    this.audio = new Audio(audioData);
    this.audio.volume = 1.0;
  }

  async startListening(restaurantId, onNewOrder) {
    if (this.unsubscribe) {
      this.stopListening();
    }

     

    try {
      const hasPermission = await this.ensurePermission();
      if (!hasPermission) {
        console.warn('⚠️ Notification permission denied');
        return;
      }

      await this.initializeFCM(restaurantId);
      this.setupFirestoreListener(restaurantId, onNewOrder);

       
    } catch (error) {
      console.error('❌ Error starting notifications:', error);
    }
  }

  async initializeFCM(restaurantId) {
    if (!messaging) {
      console.warn('⚠️ FCM not available in this browser');
      return;
    }

    try {
      const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js', {
        scope: '/',
        updateViaCache: 'none'
      });

       
      await navigator.serviceWorker.ready;

      const token = await getToken(messaging, {
      vapidKey: 'BP8d_2yy0G3JCUXlwhrCFso-yQ2zK-0DMVfoy0x-5AJvKpG-D77oa1RYFPAJrh4gS4Qhlnhyu-8Pe6eW7DOWruc',
        serviceWorkerRegistration: registration
      });
      if (token) {
         
        await this.saveTokenToFirestore(restaurantId, token);
        this.setupForegroundHandler();
      }
    } catch (error) {
      console.error('❌ FCM initialization error:', error);
    }
  }

  async saveTokenToFirestore(restaurantId, token) {
    try {
      const restaurantRef = doc(db, 'restaurants', restaurantId);
      await updateDoc(restaurantRef, {
        fcmToken: token,
        fcmTokenUpdatedAt: new Date().toISOString()
      });
       
    } catch (error) {
      console.warn('⚠️ Token not saved:', error);
    }
  }

  setupForegroundHandler() {
    if (!messaging) return;

    if (this.messageUnsubscribe) {
      this.messageUnsubscribe();
    }

    this.messageUnsubscribe = onMessage(messaging, (payload) => {
       
      
      const order = {
        id: payload.data?.orderId || Date.now().toString(),
        customerName: payload.data?.customerName || 'Customer',
        total: payload.data?.total || '0',
        tableName: payload.data?.tableName || ''
      };

      this.showNotification(order);
      this.playSound();
    });
  }

  setupFirestoreListener(restaurantId, onNewOrder) {
    const ordersRef = collection(db, 'restaurants', restaurantId, 'orders');
    const q = query(
      ordersRef,
      where('status', '==', 'Pending'),
      orderBy('time', 'desc'),
      limit(10)
    );

    this.unsubscribe = onSnapshot(q, (snapshot) => {
      snapshot.docChanges().forEach((change) => {
        if (change.type === 'added') {
          const order = { id: change.doc.id, ...change.doc.data() };
          const orderTime = new Date(order.time).getTime();

          if (orderTime > this.lastOrderTime) {
             
            
            this.showNotification(order);
            this.playSound();
            
            if (onNewOrder) {
              onNewOrder(order);
            }
          }
        }
      });
    });
  }

  stopListening() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
    }
    if (this.messageUnsubscribe) {
      this.messageUnsubscribe();
      this.messageUnsubscribe = null;
    }
     
  }

  showNotification(order) {
    if (Notification.permission === 'granted') {
      const notification = new Notification('🔔 NEW ORDER RECEIVED!', {
        body: `Order #${order.id}\n₹${order.total} - ${order.customerName || 'Customer'}${order.tableName ? '\nTable: ' + order.tableName : ''}`,
        icon: '/logo192.png',
        badge: '/logo192.png',
        tag: 'order-' + order.id,
        requireInteraction: true,
        vibrate: [300, 100, 300, 100, 300],
        silent: false,
        renotify: true,
        data: {
          orderId: order.id,
          url: window.location.origin
        }
      });

      notification.onclick = () => {
        window.focus();
        notification.close();
      };

      setTimeout(() => notification.close(), 30000);
    }
  }

  playSound() {
    try {
      if (this.audio) {
        const playCount = 3;
        let count = 0;
        
        const playAgain = () => {
          if (count < playCount) {
            this.audio.currentTime = 0;
            this.audio.play().catch((err) => {
               
            });
            count++;
            setTimeout(playAgain, 1000);
          }
        };
        
        playAgain();
      }
    } catch (error) {
       
    }
  }

  async ensurePermission() {
    if (Notification.permission === 'granted') {
      return true;
    }

    if (Notification.permission === 'denied') {
      alert('❌ Notifications blocked. Enable in browser settings:\n\n1. Click lock icon in address bar\n2. Allow notifications\n3. Reload page');
      return false;
    }

    try {
      const permission = await Notification.requestPermission();
      
      if (permission === 'granted') {
        new Notification('✅ Notifications Enabled!', {
          body: 'You will now receive order alerts',
          icon: '/logo192.png'
        });
        return true;
      }
      
      return false;
    } catch (error) {
      console.error('Error requesting permission:', error);
      return false;
    }
  }
}

export default new NotificationPollingService();